import React, { useState } from "react";

const ColorSelector = ({ small = false }) => {
  const [selectedColor, setSelectedColor] = useState("#FF5733");
  const colorsData = ["#3F3921", "#000000", "#233B1C", "#FFA500", "#3B467C"];
  return (
    <div
      className={`flex ${
        small ? "justify-start" : "justify-center"
      } mt-4 space-x-2`}
    >
      {colorsData.map((color, index) => (
        <div
          key={index}
          className={`${
            small ? `w-3 h-3` : `w-7 h-7`
          } flex items-center justify-center cursor-pointer ${
            selectedColor === color
              ? `${small ? "border-[0.5px]" : "border-[2px]"} border-[#000]`
              : "border-[0.5px] border-[#00000017]"
          } rounded-full`}
        >
          <div
            className={`${small ? `w-3 h-3` : `w-5 h-5`} rounded-full`}
            style={{ backgroundColor: color }}
            onClick={() => setSelectedColor(color)}
          ></div>
        </div>
      ))}
    </div>
  );
};

export default ColorSelector;
